import type { UserWrite } from '@/lib/users.ts';
import { AUTOMATIC_LANGUAGE } from './language.ts';

/** What a language select's value writes on a user: a language, or "Automatic". */
export function languageFields(
  choice: string,
): Pick<Partial<UserWrite>, 'language' | 'language_source'> {
  return choice === AUTOMATIC_LANGUAGE
    ? { language_source: 'default' }
    : { language: choice };
}
